export default Backbone.Model.extend({
  defaults: {
    visible: false,
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/advanced_filtering_data.js